<template>
  <div class="template-editor-title d-flex flex-column flex-shrink-0 border-b-sm ga-1 py-4 px-6">
    <p class="text-h3 text-textDarkest">
      Template Editor
    </p>
    <p class="text-body-3 text-textLight">
      Build and manage reusable approval templates
    </p>
  </div>
</template>

<script setup>
defineOptions({ name: 'TemplateEditorTitle' });
</script>
